function readEnv(value, fallback) {
  return value || fallback
}

const LOCAL_API = readEnv(process.env.VUE_APP_LOCAL_API_BASE, 'http://127.0.0.1:4444/api')
const LOCAL_WS = readEnv(process.env.VUE_APP_LOCAL_WS_BASE, 'ws://127.0.0.1:4444')
const UAT_API = readEnv(process.env.VUE_APP_UAT_API_BASE, 'https://uat-api.anan-cargo.com/api')
const UAT_WS = readEnv(process.env.VUE_APP_UAT_WS_BASE, 'wss://uat-api.anan-cargo.com')
const PROD_API = readEnv(process.env.VUE_APP_PROD_API_BASE, 'https://api.anan-cargo.com/api')
const PROD_WS = readEnv(process.env.VUE_APP_PROD_WS_BASE, 'wss://api.anan-cargo.com')

export function siteKey() {
  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  if (host === 'localhost' || host === '127.0.0.1') return 'local'
  if (host === 'uat-portal.anan-cargo.com') return 'uat'
  return 'prod'
}

export function getApiBase() {
  const key = siteKey()
  if (key === 'local') return LOCAL_API
  if (key === 'uat') return UAT_API
  return PROD_API
}

export function getWsBase() {
  const key = siteKey()
  if (key === 'local') return LOCAL_WS
  if (key === 'uat') return UAT_WS
  return PROD_WS
}
